import {Lotties} from "./Lotties";
import * as reviewResult from "../../../../assets/themes/emerge/lotties/review.json";
import * as failResult from "../../../../assets/themes/emerge/lotties/fail.json";
import * as passResult from "../../../../assets/themes/emerge/lotties/success.json";
import * as processingID from "../../../../assets/themes/emerge/lotties/processing-id.json";
import * as successTick from "../../../../assets/themes/emerge/lotties/tick.json";
import * as processingSelfie from "../../../../assets/themes/emerge/lotties/processing-selfie.json";
import * as pendingResult from "../../../../assets/themes/emerge/lotties/pending.json";
import * as processing from "../../../../assets/themes/emerge/lotties/processing.json";
import * as error from "../../../../assets/themes/emerge/lotties/error.json";


export const EmergeLotties: Lotties = {
    fail: failResult,
    pending: pendingResult,
    processComplete: successTick,
    processing: processing,
    processingId: processingID,
    processingSelfie: processingSelfie,
    review: reviewResult,
    success: passResult,
    error: error
}